import { Space } from 'antd'
import { CIMSTags } from 'components/CIMSTags'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'
import { NameDescription } from 'App/components/ProjectRoutes/components/Administration/components/ImplicitPermissionViewer/hooks/useImplicitPermissions/types'

export const useCASRoutingGroupsPanel = (
  groups: NameDescription[]
): CIMSCollapsePanelOptions[] =>
  !!groups.length
    ? [
        {
          key: `cas-routing-groups-${Math.random()}`,
          header: 'Construction & Admin Submittals',
          children: (
            <Space direction="vertical" size="small">
              {'Routing Groups:'}
              <CIMSTags
                tags={groups.map(({ name, description }) => ({
                  text: name,
                  tooltip: description,
                }))}
              />
            </Space>
          ),
        },
      ]
    : []
